import {
  CREDIT_HISTORY_CHANGED,
} from './types';

export const creditHistoryChanged = (payload) => ({
  type: CREDIT_HISTORY_CHANGED,
  payload: payload,
})
